<template>
<div class="chapterWrap">
  <div class="card-header">
    <p class="card-title">{{info.cptName}}</p>
    <p class="card-zan">
      <van-icon name="good-job-o" />
      <span>{{info.cptPraiseCount|countFilter}}</span>
    </p>
  </div>
  <div class="card-body">
    <p>
      <van-icon name="underway-o" />
      <span>{{info.cptStartTime}} - {{info.cptEndTime}}</span>
    </p>
    <p>
      <van-icon name="user-o" />
      <span>主讲教师：{{info.cptTeacher.techerName}}</span>
    </p>
  </div>
  <div class="buttons">
    <vanButton plain round class="disabled" disabled v-if="info.cptState==0">
      未开始
    </vanButton>
    <vanButton plain round class="disabled" disabled v-if="info.cptState==2">
      已结束
    </vanButton>
    <vanButton icon="bar-chart-o" plain round v-if="info.cptState==1||info.cptState==4" @click="toDownLoad"  v-track="{ name: 'live_living'}">
      直播中
    </vanButton>
    <van-button icon="play-circle-o" plain round v-if="info.cptState==5||info.cptState==6||info.cptState==3" @click="toDownLoad" v-track="{ name: 'live_huikan'}">回看</van-button>
  </div>
</div>
</template>
<script>
import Button from 'vant/lib/button'
import 'vant/lib/button/style'
import Icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
export default {
  name: 'chapter',
  props: ['info'],
  components: {
    vanIcon: Icon,
    vanButton: Button
  },
  data() {
    return {

    }
  },
  filters: {
    countFilter(number) {
      if (number > 1000000) {
        return 100 + '万+'
      }
      if (number > 10000) {
        return (number / 10000).toFixed(2) + '万'
      }
      return number
    }
  },
  methods: {
    toDownLoad() {
      this.$emit('todownload')
    }
  }
}
</script>
<style lang="scss" scoped>
.chapterWrap {
    // width: 100%;
    padding: 15px;
    background-color: #fff;
    border-radius: 5px;
    margin-bottom: 10px;
    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .card-title {
            font-size: 13px;
            color: #222222;
        }
        .card-zan {
            font-size: 12px;
            color: #999999;
            display: flex;
            align-items: center;
        }
    }
    .card-body {
        text-align: left;
        margin-top: 16px;
        p {
            font-size: 12px;
            color: #999999;
            display: flex;
            align-items: center;
            margin-bottom: 5px;
        }
    }
    .buttons {
        text-align: right;
        .van-button {
            width: 177px;
            height: 25px;
            font-size: 12px;
            color: #e85966;
            border-color: #e85966;
            border-width: 1px;
            &.disabled {
                color: #999999;
                border-color: #999999;

            }
        }
    }
}
</style>
